import { Box } from '@mui/material';
import React from 'react';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import Typography500 from 'views/common/components/UI/Typography500';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/DisclamerSection/DisclamerSection.styles';
import EagleRide from 'views/rebranded-module/common/icons/EagleRide';
import PATHS from 'lib/navigation/paths';

const DisclamerSection = (props) => {
  const { content } = props;

  return (
    <StyledBox>
      <EagleRide className="DSIcon" />
      <Box className="DSText">
        <Typography500 component="p" variant="body1" mb={0.5}>
          {content.disclamerSectionTitle}
        </Typography500>
        <Typography500 component="p" variant="body3" mb={2}>
          {content.disclamerSectionDescription}
        </Typography500>
        <NavigatorLink
          className="CLSCardBtn"
          href={PATHS.motorcycleClub.index()}>
          {content.learnMore}
        </NavigatorLink>
      </Box>
    </StyledBox>
  );
};

export { DisclamerSection };
